export default {
    upload: "file/upload",
    download: "file/download",
    delete: "file/delete",
    rename: "file/rename",
    move: "file/move",
    share: "file/share",
    email: "file/email",
    customerList: "file/customerList",
    folderContent: "file/folderContent",

    createFolder: "file/createFolder",
    downloadFolder: "file/downloadFolder",
    deleteFolder: "file/deleteFolder",
    renameFolder: "file/renameFolder",
    shareFolder: "file/shareFolder",
}